const Footer = () => {
  return (
    <footer className="px-4 py-3 text-center text-white bg-gray-900">
      <p>&copy; 2024 Gestao de Documentos. Desenvolvido por Denilson Silva. Todos os direitos reservados.</p>
    </footer>
  );
};

export default Footer;
